/**
 * 配当調整UI制御モジュール
 *
 * 機能:
 * - 譲渡人・譲受人の配当調整値入力時に合計を即座に表示
 * - Ajax経由での調整値保存とエラーハンドリング
 */

export default class DividendAdjustments {
  /**
   * DividendAdjustmentsコンストラクタ
   * 配当調整セクション要素を検索・保持
   */
  constructor() {
    this.sections = document.querySelectorAll('.dividend-adjustment-section');
  }

  /**
   * イベントハンドラーをアタッチ
   * セクションが存在する場合のみ実行
   */
  attachEvent() {
    if (this.sections.length === 0) return;

    this.setupTotalCalculation();
    this.setupFormSubmission();
  }

  /**
   * 合計金額の自動計算を設定
   */
  setupTotalCalculation() {
    this.sections.forEach((section) => {
      const inputs = section.querySelectorAll('.dividend-input');
      const totalElement = section.querySelector('.total-adjusted');

      if (!totalElement || inputs.length === 0) return;

      // 各入力欄の変更を監視
      inputs.forEach((input) => {
        input.addEventListener('input', () => this.updateTotal(inputs, totalElement));
      });

      // 初期表示時の合計を計算
      this.updateTotal(inputs, totalElement);
    });
  }

  /**
   * 入力値の合計を計算して表示を更新
   * @param {NodeList} inputs - 入力欄のNodeList
   * @param {HTMLElement} totalElement - 合計表示要素
   */
  updateTotal(inputs, totalElement) {
    const sum = Array.from(inputs).reduce((total, input) => {
      const value = parseInt(input.value || '0', 10);
      return total + (isNaN(value) ? 0 : value);
    }, 0);

    totalElement.textContent = `¥${sum.toLocaleString('ja-JP')}`;
  }

  /**
   * Ajaxフォーム送信のイベントハンドリングを設定
   */
  setupFormSubmission() {
    const forms = document.querySelectorAll('.dividend-adjustment-form');

    forms.forEach((form) => {
      form.addEventListener('ajax:success', (event) => this.handleSuccess(event));
      form.addEventListener('ajax:error', (event) => this.handleError(event));
    });
  }

  /**
   * フォーム送信成功時の処理
   * @param {Event} event - Ajaxイベント
   */
  handleSuccess(event) {
    if (!event.detail) {
      alert('通信エラーが発生しました');
      return;
    }

    const [data] = event.detail;
    alert(data.message || '保存しました');
    location.reload();
  }

  /**
   * フォーム送信エラー時の処理
   * @param {Event} event - Ajaxイベント
   */
  handleError(event) {
    if (!event.detail) {
      alert('通信エラーが発生しました');
      return;
    }

    const [data] = event.detail;
    alert(`エラー: ${data?.error || '保存に失敗しました'}`);
  }
}
